module.exports = __webpack_public_path__ + "static/media/person.3249d6b0.png";